module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"year":"År","month":"Måned","day":"Dag","yearAbbr":"Å","monthAbbr":"M","dayAbbr":"D"},"en":{"year":"Year","month":"Month","day":"Day","yearAbbr":"Y","monthAbbr":"M","dayAbbr":"D"}}')
  delete Component.options._Ctor
}
